export default "<div  class=\"modal\">\n    <div class=\"logo\">\n    </div>\n</div>\n"